import http from "../http-common";

class SinvoiceViettelService {
    /**
     * Lưu thông tin cấu hình Sinvoice Viettel
     */
    saveCustomerInformation(data) {
        return http.post(`/electronic-invoice-config`, data);
    }

    /**
     * Lấy thông tin cấu hình Sinvoice Viettel theo trường
     */
    getCustomerInformation() {
        return http.get(`/electronic-invoice-config`);
    }

    /**
     * Cập nhật thông tin cấu hình Sinvoice Viettel
     */
    updateCustomerInformation(id, data) {
        return http.put(`/electronic-invoice-config/${id}`, data);
    }

    /**
     * Kiểm tra kết nối Sinvoice API
     */
    testConnection(data) {
        return http.post(`/electronic-invoice-config/test-connection`, data);
    }

    /**
     * Lấy thông tin user
     */
    getInformationKids(kidCode){
        return http.get(`/electronic-invoice-config/information/${kidCode}`);
    }

    /**
     * Lấy taxCode
     */
    getTaxCode(){
        return http.get(`/electronic-invoice-config/tax-code`);
    }


}

export default new SinvoiceViettelService();
